// src/components/Layout.js
import React, { useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../component/header";
import SideMenu from "../component/sideMenu";
import { Box, CssBaseline, IconButton } from "@mui/material";
import { useMinimized } from "../helper/context/sideMenuContext/menuContext";
import { useResponsive } from "../helper/use-reponsive";
import CloseIcon from "@mui/icons-material/Close";
import MarkChatUnreadRoundedIcon from "@mui/icons-material/MarkChatUnreadRounded";
import AddIsChatBoxHelpdesksue from "../pages/helpdesk/chatboxHelpdesk.jsx";
import { AuthContext } from "../helper/context/auth/authContext";
import { UploadProvider, useUpload } from "../helper/context/upload/uploadContext";
import BulkPayslipUploader from "../pages/payRoll/payroll-lockScreen/PayslipUploaderBase64";
import { useRef, useEffect } from "react";

const LayoutInternal = () => {
  const { isMinimized } = useMinimized();
  const upLg = useResponsive("up", "lg");
  const [chatOpen, setChatOpen] = useState(false);
  const uploaderRef = useRef(null);
  const { user } = useContext(AuthContext);
  const { uploadData, setUploadData, setUploadStatus, uploadStatus } = useUpload();

  useEffect(() => {
    if (uploadData && uploaderRef.current) {
      const performUpload = async () => {
        const result = await uploaderRef.current.uploadPayslips();
        if (uploadData.onUploadComplete) {
            uploadData.onUploadComplete(result);
        }
        setUploadData(null); // Clear the upload job
      };
      performUpload();
    }
  }, [uploadData, setUploadData, uploadStatus]);


  return (
    <Box sx={{ width: "100vw", height: "100vh", position: "relative" }}>
      {uploadData && (
        <BulkPayslipUploader
          ref={uploaderRef}
          user={user}
          listDownload={uploadData.listDownload}
          monthName={uploadData.monthName}
          fileName={uploadData.fileName}
          processPeriod={uploadData.processPeriod}
          formData={uploadData?.formData}
          // This uploader is now controlled by the useEffect above
        />
      )}
      <CssBaseline />
      <Header />
      <SideMenu />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 2,
          marginLeft: upLg && (isMinimized ? "60px" : "220px"),
          transition: "margin-left 0.3s ease",
        }}
      >
        <Outlet />
      </Box>

      {/* Chat Toggle Button */}
      <IconButton
        onClick={() => setChatOpen(!chatOpen)}
        sx={{
          position: "fixed",
          bottom: 20,
          right: 25,
          backgroundColor: "#1976d2",
          color: "white",
          width: 48,
          height: 48,
          "&:hover": { backgroundColor: "#1565c0" },
          boxShadow: 4,
          // zIndex: 1300,
        }}
      >
        {chatOpen ? <CloseIcon /> : <MarkChatUnreadRoundedIcon />}
      </IconButton>

      {/* Helpdesk Chat Panel */}
      <AddIsChatBoxHelpdesksue  open={chatOpen} setOpen={setChatOpen} />
    </Box>
  );
}

const Layout = () => {
  return (
    <UploadProvider>
      <LayoutInternal />
    </UploadProvider>
  );
};

export default Layout;
